import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { getDiscountPrice } from "../../helpers/product";
import {
  addToWishlist,
  removeFromWishlist,
  removeAllFromWishlist
} from "../../redux/actions/wishlistActions";
import { addToCart } from "../../redux/actions/cartActions";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import ProductModal from "../../components/product/ProductModal";
import { addToCompare } from "../../redux/actions/compareActions";

const Wishlist = ({
  location,
  cartItems,
  products,
  currency,
  addToCart,
  wishlistItems,
  removeFromWishlist,
  removeAllFromWishlist,
  userData,
  addToCompare,
  compareItems
}) => {
  const isLoggedUser = (((userData?.user?.user) && (userData?.user?.user?.IDCli || userData?.user?.user?.IDAge))) ? true : false;
  const visualizzaPrezzi = isLoggedUser || global.visualizzaPrezziLogOut;
  const visualizzaGriglia = isLoggedUser || global.visualizzaGrigliaLogOut;
  const visualizzaQuantita = isLoggedUser || global.visualizzaQuantitaLogOut;
  const prodottiSenzaLogin = global.prodottiSenzaLogin;

  const [modalShow, setModalShow] = useState({ visible: false, product: {} });
  const { addToast } = useToasts();
  const { pathname } = location;
  var strings = require("../../translations/italian.json");

  const nascondiModal = () => {
    const item = { ...modalShow }
    setModalShow({ ...item, visible: false })
  }

  return (
    <>
      <Fragment>
        <MetaTags>
          <title>{strings.wishlist} | {strings.titleSite}</title>
          <meta
            name="description"
            content={strings.wishlist + " " + strings.siteContent}
          />
        </MetaTags>


        <LayoutOne>
          {/* breadcrumb */}

          <div className="cart-main-area pt-20 pb-20">
            <div className="container">
              {wishlistItems && wishlistItems.length >= 1 ? (
                <Fragment>
                  <h3 className="cart-page-title">Lista dei preferiti - Articoli</h3>
                  <div className="row">
                    <div className="col-12">
                      <div className="table-content table-responsive cart-table-content">
                        <table>
                          <thead>
                            <tr>
                              <th>Immagine</th>
                              <th>Prodotto</th>
                              {/*<th>Prezzo</th>*/}
                              <th>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Visualizza&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</th>
                              <th>Azione</th>
                            </tr>
                          </thead>
                          <tbody>
                            {wishlistItems.map((wishlistItem, key) => {





                              const product = products.find(_product => _product?.id === wishlistItem?.id);
                              if (!product) return null;

                              const discountedPrice = !product ? 0 : getDiscountPrice(product.price, product.discount, product.pricesco);
                              const finalProductPrice = !product ? 0 : (product.price * currency.currencyRate).toFixed(2);
                              const finalDiscountedPrice = !product ? 0 : (discountedPrice * currency.currencyRate).toFixed(2);
                              const cartItem = cartItems.filter(item => item.id === product.id)[0]

                              return (
                                <>
                                  <tr key={key}>
                                    <td className="product-thumbnail">
                                      <Link
                                        to={
                                          process.env.PUBLIC_URL +
                                          "/product/" +
                                          product.id
                                        }
                                      >
                                        <img
                                          className="img-fluid"
                                          src={
                                            global.baseUrlImage +
                                            product.image[0]
                                          }
                                          alt=""
                                        />
                                      </Link>
                                    </td>

                                    <td className="product-name text-center w-200">
                                      <Link
                                        to={
                                          process.env.PUBLIC_URL +
                                          "/product/" +
                                          product.id
                                        }
                                      >
                                        {product.sku}
                                      </Link>
                                      <br />
                                      <Link
                                        to={
                                          process.env.PUBLIC_URL +
                                          "/product/" +
                                          product.id
                                        }
                                      >
                                        {product.name}
                                      </Link>
                                    </td>

                                    <td className="product-price-cart" style={{ display: "none" }}>
                                      {discountedPrice !== null ? (
                                        <Fragment>
                                          <span className="amount old">
                                            {currency.currencySymbol +
                                              finalProductPrice}
                                          </span>
                                          <span className="amount">
                                            {currency.currencySymbol + finalDiscountedPrice}
                                          </span>
                                        </Fragment>
                                      ) : (
                                        <span className="amount">
                                          {currency.currencySymbol +
                                            finalProductPrice}
                                        </span>
                                      )}
                                    </td>

                                    <td className="product-wishlist-cart">
                                      {product.affiliateLink ? (
                                        <a
                                          href={product.affiliateLink}
                                          rel="noopener noreferrer"
                                          target="_blank"
                                        >
                                          {" "}
                                          Acquista Ora{" "}
                                        </a>
                                      ) : product.variation &&
                                        product.variation.length >= 1 ? (
                                        <button
                                          onClick={() => setModalShow({ visible: true, product, cartItem, wishlistItem, discountedPrice, finalProductPrice, finalDiscountedPrice })}
                                        >
                                          Visualizza
                                        </button>


                                      ) : product.stock &&
                                        product.stock > 0 ? (
                                        <button
                                          onClick={() =>
                                            addToCart(product, addToast)
                                          }
                                          className={
                                            cartItem !== undefined &&
                                              cartItem.quantity > 0
                                              ? "active"
                                              : ""
                                          }
                                          disabled={
                                            cartItem !== undefined &&
                                            cartItem.quantity > 0
                                          }
                                          title={
                                            wishlistItem !== undefined
                                              ? strings.added_to_cart
                                              : strings.add_to_cart
                                          }
                                        >
                                          {cartItem !== undefined &&
                                            cartItem.quantity > 0
                                            ? "Aggiunto"
                                            : strings.add_to_cart}
                                        </button>
                                      ) : (
                                        <button disabled className="active">
                                          Out of stock
                                        </button>
                                      )}
                                    </td>

                                    <td className="product-remove">
                                      <button
                                        onClick={() =>
                                          removeFromWishlist(wishlistItem, addToast)
                                        }
                                      >
                                        <i className="fa fa-times"></i>
                                      </button>
                                    </td>
                                  </tr>


                                </>
                              );




                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="cart-shiping-update-wrapper">
                        <div className="cart-shiping-update">
                          <Link
                            to={process.env.PUBLIC_URL + "/shop-grid-full-width"}
                          >
                            Continua gli Acquisti
                          </Link>
                        </div>
                        <div className="cart-clear">
                          <button onClick={() => removeAllFromWishlist(addToast)}>
                            Cancella Lista
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fragment>
              ) : (
                <div className="row">
                  <div className="col-lg-12">
                    <div className="item-empty-area text-center">
                      <div className="item-empty-area__icon mb-30">
                        <i className="pe-7s-like"></i>
                      </div>
                      <div className="item-empty-area__text">
                        Nessun Articolo nella Lista dei preferiti <br />{" "}
                        <Link to={process.env.PUBLIC_URL + "/shop-grid-full-width"}>
                          Aggiungi Articolo
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </LayoutOne>



      </Fragment>

      {modalShow.visible && <ProductModal
        //setModalShow({ visible: true, product, cartItem, wishlistItem, discountedPrice, finalProductPrice, finalDiscountedPrice })}
        isLoggedUser={isLoggedUser}
        visualizzaPrezzi={visualizzaPrezzi}
        show={modalShow.visible}
        onHide={() => nascondiModal()}
        product={modalShow?.product}
        currency={currency}
        discountedprice={modalShow?.discountedPrice || 0}
        finalproductprice={modalShow?.finalproductprice || 0}
        finaldiscountedprice={modalShow?.finaldiscountedprice || 0}
        cartitem={modalShow?.cartitem || {}}
        wishlistitem={modalShow?.wishlistitem || {}}
        //compareitem={compareItem}
        addtocart={addToCart}
        addtowishlist={addToWishlist}
        addtocompare={addToCompare}
        addtoast={addToast}
        compareItem={
          compareItems.filter(
            compareItem => compareItem.id === modalShow?.product?.id
          )[0]
        }
      />}
    </>
  );
};

Wishlist.propTypes = {
  addToCart: PropTypes.func,
  cartItems: PropTypes.array,
  currency: PropTypes.object,
  location: PropTypes.object,
  removeAllFromWishlist: PropTypes.func,
  removeFromWishlist: PropTypes.func,
  wishlistItems: PropTypes.array,
  addToCompare: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    currency: state.currencyData,
    userData: state.userData,
    products: state.productData.products,
    compareItems: state.compareData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (item, addToast, quantityCount, selectedProductColor, selectedProductSize, selectedIDArt,) => {
      dispatch(addToCart(item, addToast, quantityCount, selectedProductColor, selectedProductSize, selectedIDArt));
    },
    addToWishlist: (item, addToast, quantityCount) => {
      dispatch(addToWishlist(item, addToast, quantityCount));
    },
    removeFromWishlist: (item, addToast, quantityCount) => {
      dispatch(removeFromWishlist(item, addToast, quantityCount));
    },
    removeAllFromWishlist: addToast => {
      dispatch(removeAllFromWishlist(addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
